import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type InviteState = {
  dataDetail?: InviteDetail;
  loading: boolean;
  filter: any
};

export const inviteInitialState: InviteState = {
  dataDetail: undefined,
  loading: false,
  filter: null
};

const slice = createSlice({
  name: 'invite',
  initialState: inviteInitialState,
  reducers: {
    setInviteDetailAction(state, { payload }: PayloadAction<InviteDetail | undefined>) {
      state.dataDetail = payload || undefined;
    },
    setInviteLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    }
  },
});

export const {
  setInviteDetailAction,
  setInviteLoading,
} = slice.actions;
export default slice.reducer;

